export default __webpack_public_path__ + "static/licence-TAS-23a984bc6128d71a760d2dc6ee2b8b1b.svg";